import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "MobileLandscape"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M2.25 7.5V16.5C2.25083 17.3281 2.92192 17.9992 3.75 18H20.25C21.0781 17.9992 21.7492 17.3281 21.75 16.5V7.5C21.7488 6.67209 21.0779 6.00124 20.25 6H3.75C2.92192 6.00083 2.25083 6.67192 2.25 7.5ZM3.75 7.5H5.25V16.5H3.75V7.5ZM20.25 16.5H6.75V7.5H20.25V16.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/MobileLandscape.vue"]]);
